<template>
  <div class="container col-10">
    <div class="ContainerRecordatorio">
      <div class="ContainerRecorda">
        <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
        <p>
          <span>
            {{ $t('report.label.starsBalance.description') }}
          </span>
        </p>
      </div>
    </div>

    <!-- Búsqueda de usuario -->
    <div class="headerReport">
      <div v-if="loading" class="text-center">
        <v-progress-circular
          class="mt-auto"
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      
      <div v-else>
        <!-- Formulario de búsqueda -->
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
          <!-- Búsqueda de usuario -->
          <v-row class="justify-center mb-4">
            <v-col cols="12" md="8">
              <v-text-field
                :label="$t('starAssignment.label.search')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                v-model="searchUser"
                outlined
                :loading="loadingUsers"
                clearable
                @keyup.enter.prevent
                hide-details
              ></v-text-field>
              
              <!-- Lista de usuarios -->
              <v-list 
                v-if="searchUser && searchUser.length >= 3" 
                class="scrollable-list elevation-2" 
                style="max-height: 200px; margin-top: 8px;"
              >
                <v-list-item-group v-if="filteredAffiliates.length">
                  <v-list-item
                    v-for="user in filteredAffiliates"
                    :key="user.userId"
                    @click="selectUser(user)"
                    class="py-2"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="body-2">
                        {{ user.firstName }} {{ user.middleName }}
                        {{ user.lastName }} {{ user.secondLastName }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption">
                        {{ user.identificationNumber }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title class="text-center grey--text">
                      {{ $t('chart.label.notData') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-form>

        <!-- Información del usuario seleccionado -->
        <v-row v-if="selectedUser" class="justify-center mb-4">
          <v-col cols="12" md="8">
            <v-card outlined class="blue-grey lighten-5">
              <v-card-subtitle class="primary--text font-weight-bold py-2 d-flex justify-space-between align-center">
                <span>{{ $t('report.label.starsBalance.userInfo') }}</span>
                <v-btn
                  icon
                  x-small
                  color="grey"
                  @click="clearSelectedUser"
                  class="ml-2"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-subtitle>
              <v-card-text class="pa-2">
                <div class="user-info">
                  <strong>{{ selectedUser.firstName }} {{ selectedUser.middleName }} {{ selectedUser.lastName }} {{ selectedUser.secondLastName }}</strong>
                  <div class="caption grey--text">
                    {{ selectedUser.emailAddress }}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              fixed
              bottom
              right
              dark
              large
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="submitForm"
              :loading="loading"
              style="z-index: 1000;"
            >
              <v-icon dark>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('button.download') }}</span>
        </v-tooltip>

        <!-- Resultados del reporte -->
        <div v-if="reportData" class="mt-6">
          <h3 class="headline primary--text mb-3 text-center">
            {{ $t('report.label.starsBalance.reportInfo') }}
          </h3>
          
          <v-row class="justify-center">
            <v-col cols="12" md="8">
              <v-simple-table class="elevation-2">
                <thead>
                  <tr class="primary">
                    <th class="text-left white--text" scope="col" id="totalStars">{{ $t('report.label.starsBalance.totalStars') }}</th>
                    <th class="text-left white--text" scope="col" id="availableStars">{{ $t('report.label.starsBalance.availableStars') }}</th>
                    <th class="text-left white--text" scope="col" id="usedStars">{{ $t('report.label.starsBalance.usedStars') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="title font-weight-bold text-center">{{ reportData.totalStars || 0 }}</td>
                    <td class="success--text font-weight-bold text-center">{{ reportData.availableStars || 0 }}</td>
                    <td class="warning--text font-weight-bold text-center">{{ reportData.usedStars || 0 }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>

    <!-- Success/Error Messages -->
    <v-snackbar v-model="showMessage" :color="messageType" timeout="3000">
      {{ message }}
    </v-snackbar>
  </div>
</template>

<script>
import { service as reports_service } from "@/services/reports_service.js";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import i18n from "@/plugins/i18n";
import {
  USERSADMIN_M,
  ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES,
  GET_STARASSIGNMENT_SEARCHAFFILIATES,
} from "@/views/users_admin/store/types/types.js";

export default {
  name: "formStarsBalanceComponent",
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      loadingUsers: false,
      searchUser: "",
      selectedUserId: null,
      selectedUser: null,
      usersList: [],
      reportData: null,
      showMessage: false,
      message: "",
      messageType: "success"
    };
  },
  computed: {
    ...mapGetters({
      searchAffiliates: [`${USERSADMIN_M}${GET_STARASSIGNMENT_SEARCHAFFILIATES}`],
    }),

    filteredAffiliates() {
      if (this.searchUser.length < 3) {
        return [];
      }
      
      // Verificar si searchAffiliates está disponible
      if (!this.searchAffiliates || !Array.isArray(this.searchAffiliates)) {
        return [];
      }
      
      const searchTerms = this.searchUser.toLowerCase().split(/\s+/);
      
      return this.searchAffiliates
        .filter((affiliate) => {
          const fullName = `${affiliate.firstName} ${
            affiliate.middleName || ""
          } ${affiliate.lastName} ${
            affiliate.secondLastName || ""
          }`.toLowerCase();
          return searchTerms.every((term) => fullName.includes(term));
        })
        .map((affiliate) => ({
          ...affiliate,
          fullName: `${affiliate.firstName || ''} ${affiliate.middleName || ''} ${affiliate.lastName || ''} ${affiliate.secondLastName || ''}`.trim()
        }));
    }
  },
  watch: {
    searchUser(newTerm) {
      if (newTerm && newTerm.length >= 3) {
        this.fetchAffiliates();
      }
    },
  },
  methods: {
    ...mapActions({
      getActionSearchAffiliates: `${USERSADMIN_M}${ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES}`,
    }),

    validateForm() {
      const errors = {};

      if (!this.selectedUserId) {
        errors.selectedUserId = this.$t('report.label.starsBalance.selectUserFirst');
      }

      return errors;
    },

    async submitForm() {
      const validationErrors = this.validateForm();
      if (Object.keys(validationErrors).length > 0) {
        const errorMessages = Object.values(validationErrors).join("<br>");
        Swal.fire({
          icon: "error",
          title: i18n.t('label.errorsValidation.plural.title'),
          html: '<div class="swal-subtitle"><b>' + i18n.t('label.errorsValidation.text') + ':</b></div><br>' + errorMessages,
          confirmButtonColor: '#6E17A5'
        });
        return;
      }

      await this.generateAndDownload();
    },

    async fetchAffiliates() {
      if (this.searchUser.length >= 3) {
        this.loadingUsers = true;
        try {
          await this.getActionSearchAffiliates(this.searchUser);
        } catch (error) {
          this.showMessage = true;
          this.message = this.$t('report.label.starsBalance.errorSearchingUsers');
          this.messageType = "error";
        } finally {
          this.loadingUsers = false;
        }
      }
    },

    selectUser(user) {
      this.selectedUser = user;
      this.selectedUserId = user.userId;
      this.searchUser = `${user.firstName} ${user.middleName} ${user.lastName} ${user.secondLastName}`.trim();
      this.reportData = null;
    },

    clearSelectedUser() {
      this.selectedUser = null;
      this.selectedUserId = null;
      this.searchUser = "";
      this.reportData = null;
    },

    async generateReport() {
      if (!this.selectedUserId) {
        this.showMessage = true;
        this.message = this.$t('report.label.starsBalance.selectUserFirst');
        this.messageType = "error";
        return;
      }

      this.loading = true;
      try {
        const response = await reports_service.generateStarsBalanceReport(
          sessionStorage.getItem("idGroup"),
          sessionStorage.getItem("idEmpresa"),
          sessionStorage.getItem("idUsuario"),
          this.selectedUserId
        );

        if (response.data && response.data.payload) {
          if (response.data.payload.url != null) {
            this.reportData = {
              downloadUrl: response.data.payload.url,
              totalStars: this.extractStarsFromUrl(response.data.payload.url)
            };
            this.showMessage = true;
            this.message = this.$t('report.label.starsBalance.reportGenerated');
            this.messageType = "success";
          } else {
            Swal.fire({
              icon: "info",
              title: i18n.t('report.label.downloadExcel.title'),
              text: response.data.payload.message || 'No hay información para descargar',
            });
            return;
          }
        }
      } catch (error) {
          this.showMessage = true;
          this.message = this.$t('report.label.starsBalance.errorGeneratingReport');
          this.messageType = "error";
        } finally {
        this.loading = false;
      }
    },

    async generateAndDownload() {
      if (!this.selectedUserId) {
        this.showMessage = true;
        this.message = this.$t('report.label.starsBalance.selectUserFirst');
        this.messageType = "error";
        return;
      }

      // Obtener datos de sesión
      const idGroup = sessionStorage.getItem("idGroup");
      const idEmpresa = sessionStorage.getItem("idEmpresa");
      const idUsuario = sessionStorage.getItem("idUsuario");

      this.loading = true;
      try {
        const response = await reports_service.generateStarsBalanceReport(
          idGroup,
          idEmpresa,
          idUsuario,
          this.selectedUserId
        );

        if (response.data && response.data.payload) {
          if (response.data.payload.url != null) {
            this.downloadExcelFile(response.data.payload.url);
            this.showMessage = true;
            this.message = this.$t('report.label.starsBalance.reportGenerated');
            this.messageType = "success";
          } else {
            Swal.fire({
              icon: "info",
              title: i18n.t('report.label.downloadExcel.title'),
              text: response.data.payload.message || 'No hay información para descargar',
            });
            return;
          }
        }
      } catch (error) {
          this.showMessage = true;
          this.message = this.$t('report.label.starsBalance.errorGeneratingReport');
          this.messageType = "error";
        } finally {
        this.loading = false;
      }
    },

    downloadExcelFile(responseUrl) {
      // Crear enlace y descargar directamente
      const link = document.createElement('a');
      link.href = responseUrl;
      link.target = '_blank';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    extractStarsFromUrl(url) {
      // Intentar extraer el número de estrellas del nombre del archivo
      const match = url.match(/(\d+)_stars_balance/);
      return match ? parseInt(match[1]) : 0;
    }
  }
};
</script>

<style scoped>
.affiliates-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.affiliates-count {
  color: #ff7900;
  margin-left: 14px;
}

.custom-btn {
  width: 40px;
  height: 40px;
}

.custom-icon {
  font-size: 22px;
  color: #6e17a5 !important;
}

.container {
  margin: 0 auto;
  padding: 20px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.headerReport {
  margin-bottom: 30px;
}

.user-info {
  line-height: 1.4;
}

.scrollable-list {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow-y: auto;
}

.v-list-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.v-list-item:hover {
  background-color: #f5f5f5;
}

.v-list-item--active {
  background-color: #e3f2fd;
  color: #1976d2;
}
</style>
